import * as React from "react";
import Component from "../../AbstractComponent";
import Charge2Summary from "./Charge2Summary";
import Charge2DetailsReadonly from "./Charge2DetailsReadonly";
import ChargeDetailsEditableNewCounterpartyLookup from "./ChargeDetailsEditableNewCounterpartyLookup";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import {
	Card
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class Charge2Card extends Component {
	public state = {
		isSummaryView: true,
		isEditableView: false
	};

  constructor(public props) {
    super(props);

		let isSummaryView = true;

		if (this.props.dialogPresentation) {
			isSummaryView = false;
		}

		if (typeof this.props.isSummaryView !== "undefined") {
			isSummaryView = this.props.isSummaryView;
		}

		this.state.isSummaryView = isSummaryView;
	}

	public changeView = (): void => {
		if (typeof this.props.settledChargeIdForDetailsPresentation !== "undefined") {
			this.props.changePaymentIdForDetailsPresentation.call(this, null);
			if (this.props.settledChargeIdForDetailsPresentation === this.props.charge?.id) {
				this.props.changeSettledIdForDetailsPresentation.call(this, null);
			} else {
				this.props.changeSettledIdForDetailsPresentation.call(this, this.props.charge?.id);
			}
		} else {
			this.setState({
				isSummaryView: !this.state.isSummaryView
			})
		}
	}

	public openEditableView = () => {
		this.props.openEditableView();
		this.setState({
			isEditableView: true,
			isSummaryView: false
		})
	}
	
  public render() {
		const charge: ChargeInterface = this.props.charge;
		const linkedPayment = this.props.linkedPayment;
		const isSummaryView = typeof this.props.settledChargeIdForDetailsPresentation !== "undefined" ? 
														this.props.settledChargeIdForDetailsPresentation !== charge?.id : 
														this.state.isSummaryView;
														
    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
				onClick={isSummaryView ? this.changeView : null}
			>
				<div 
					className="right-buttons" 
					style={{
						position: "absolute",
						right: 0,
						width: "100%",
						height: "60px",
						display: "flex",
						justifyContent: "flex-end",
						paddingRight: "7px"
					}} 
					onClick={!isSummaryView ? this.changeView : null}
				>
					{
						this.props.dialogPresentation ? 
						null :
						isSummaryView ? 
							<ExpandMore style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/> : 
							<ExpandLess style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/>
					}
				</div>

				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
					<div style={{display: isSummaryView ? "block" : "none"}}>
						<Charge2Summary {...this.props} charge={charge} linkedPayment={linkedPayment} />
					</div>
					<div style={{display: !isSummaryView && !this.state.isEditableView ? "block" : "none"}}>
						<Charge2DetailsReadonly {...this.props} charge={charge} linkedPayment={linkedPayment} openEditableView={this.openEditableView} />
					</div>

					<div style={{display: !isSummaryView && this.state.isEditableView && this.props.newCounterpartyLookup ? "block" : "none"}}>
						<ChargeDetailsEditableNewCounterpartyLookup {...this.props} charge={charge} />
					</div>
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
